<template lang="pug">
div
  el-card(shadow="hover").card-container
    p.padding-titulo Pesquisa de Modelos
    app-filtro(
      @pesquisar="pesquisar"
      @limparCampos="limpar"
      :hasButtonLimpar="true"
      :hasButtonsPesquisaAvancada="false"
      placeholderSimples="Informe a descrição"
    )
  app-listagem.listagemModelo(
    :has-refresh-button="true",
    :hasActionButton="true",
    @click="abrirModalAdicionar"
    @updateListagem="updateListagem",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="filtroConfigs.totalElements",
    @changePage="changePage",
    :pagina="filtroConfigs.number || 0"
    tituloCard="Listagem de Modelos"
    nameActionButton="Adicionar modelo"
    dadosNaoEncontrado="Não existe modelos disponíveis."
    headerLabel=""
    @executar="abrirModalGenerico"
  )
  app-modal-adicionar-modelo(
    v-if="showModalAdicionar",
    @updateAoAdicionar="updateListagem"
    @closeModal="closeModal",
  )
  app-modal-visualizar-modelo(
    v-if="showModalGenerico && tipoAcao === 'VISUALIZAR'",
    @closeModal="closeModal"
    :modelo="modelo"
    :titulo="tituloModal"
  )
  app-modal-editar-modelo(
    v-if="showModalGenerico && tipoAcao === 'EDITAR'",
    @closeModal="closeModal"
    @updateAoEditar="updateListagem"
    :modelo="modelo"
    :titulo="tituloModal"
  )
  app-modal(
    v-if="showModalGenerico && tipoAcao === 'EXCLUIR'",
    @closeModal="closeModal"
    :titulo="tituloModal"
  )
    //- MODAL EXCLUIR
    template(slot="body")
      div.container
        p {{ `Tem certeza que deseja excluir o "${modelo.descricaoTexto}"? Após exclusão, não será possível utilizar este modelo padrão.` }}
    template(slot="footer")
      .flex-buttons
        el-button(@click="closeModal") Cancelar &nbsp
          .fa.fa-times
        el-button(type="primary", @click="excluirModelo") Confirmar &nbsp
          .fa.fa-check

</template>

<script>
import FileSaver from 'file-saver'
import axios from '@/utils/api'
import AppListagem from '@/components/AppListagem'
import AppFiltro from '@/components/AppFiltro'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppModal from '@/components/AppModal'
import AppModalAdicionarModelo from '@/screens/analise/components/AppModalAdicionarModelo'
import AppModalVisualizarModelo from '@/screens/analise/components/AppModalVisualizarModelo'
import AppModalEditarModelo from '@/screens/analise/components/AppModalEditarModelo'
import { mapActions } from 'vuex'
export default {
  components: {
    AppListagem,
    AppFiltro,
    AppModal,
    AppModalAdicionarModelo,
    AppModalVisualizarModelo,
    AppModalEditarModelo
  },
  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      items: [],
      totalElements: 12,
      showModalAdicionar: false,
      showModalGenerico: false,
      modelo: {},
      titulos: {
        VISUALIZAR: 'Visualizar',
        EDITAR: 'Editar',
        EXCLUIR: 'Excluir'
      },
      filtroConfigs: {},
      showUpload: false,
      errorsAnexo: [],
      colunas: [
        { id: 0, titulo: 'Modelo', propriedade: 'tipoModelo', ordem: 1, acoes: [] },
        { id: 1, titulo: 'Tipo', propriedade: 'tipoReurb', ordem: 2, exibir: () => this.isMaranhao, acoes: [] },
        { id: 2, titulo: 'Reurb Coletivo', propriedade: 'numeroProcessoReurbColetivo', ordem: 3, exibir: () => this.isMaranhao, acoes: [] },
        { id: 3, titulo: 'Município', propriedade: 'nomeMunicipio', ordem: 4, exibir: () => this.isMaranhao, acoes: [] },
        { id: 4, titulo: 'Descrição', propriedade: 'descricaoTexto', ordem: 2, acoes: [] },
        { id: 5, titulo: 'Situação', propriedade: 'situacao', ordem: 2, acoes: [], exibir: () => this.isMaranhao },
        { id: 6, titulo: 'Responsável', propriedade: 'nomeResponsavel', ordem: 3, acoes: [] },
        { id: 7, titulo: 'Data de atualização', propriedade: 'dataAtualizacao', ordem: 4, acoes: [] },
        { id: 8, titulo: 'Ações', propriedade: 'tipo', ordem: 5,  //eslint-disable-line
          acoes: [
            { id: 0, nome: 'Visualizar', codigo: 'VISUALIZAR', icone: 'fa-eye', ordem: 1 },
            { id: 1, nome: 'Editar', codigo: 'EDITAR', icone: 'fa-edit', ordem: 2 },
            { id: 2, nome: 'Excluir', codigo: 'EXCLUIR', icone: 'fa-trash', ordem: 3 }
          ]
        }
      ]
    }
  },

  async created () {
    const data = await this.findByFiltro({ campoSimples: '' })
    this.setItemsFiltroConfigs(data)
  },

  computed: {
    campoSimples () {
      return ''
    },
    tituloModal () {
      let titulo = this.titulos[this.tipoAcao]
      return `${titulo} - ${this.modelo.descricaoTexto}`
    },
    isMaranhao () {
      return process.env.ESTADO === 'ma'
    }
  },

  methods: {
    ...mapActions({
      findByFiltro: 'modeloDespacho/findByFiltro',
      excluirModeloDespacho: 'modeloDespacho/excluirModeloDespacho'
    }),

    async updateListagem () {
      const data = await this.findByFiltro({ campoSimples: this.campoSimples })
      this.setItemsFiltroConfigs(data)
      this.filtroConfigs.number = 0
      this.items = data.content
    },

    async pesquisar (filtro) {
      const data = await this.findByFiltro({ campoSimples: filtro.campoSimples, pagina: 0 })
      this.setItemsFiltroConfigs(data)
    },

    async changePage (newPage) {
      const data = await this.findByFiltro({ campoSimples: '', pagina: newPage - 1 })
      this.setItemsFiltroConfigs(data)
    },

    setItemsFiltroConfigs (data) {
      this.filtroConfigs = data
      // Formatar itens para exibir hífen quando não for modelo Reurb e formatar tipoReurb
      this.items = (data.content || []).map(item => {
        if (!item.tipoReurb) {
          item.tipoReurb = '-'
          item.numeroProcessoReurbColetivo = '-'
          item.nomeMunicipio = '-'
        } else {
          // Formatar exibição: REURB_S -> REURB S, REURB_E -> REURB E
          if (item.tipoReurb === 'REURB_S') {
            item.tipoReurb = 'REURB S'
          } else if (item.tipoReurb === 'REURB_E') {
            item.tipoReurb = 'REURB E'
          }
        }

        if (!item.situacao) {
          item.situacao = '-'
        } else {
          // Formatar exibição: FINALIZADO -> Finalizado, EM_ANDAMENTO -> Em andamento
          if (item.situacao === 'FINALIZADO') {
            item.situacao = 'Finalizado'
          } else if (item.situacao === 'EM_ANDAMENTO') {
            item.situacao = 'Em andamento'
          }
        }

        return item
      })
    },

    abrirModalAdicionar () {
      this.showModalAdicionar = true
    },

    closeModal () {
      this.showModalGenerico = false
      this.showModalAdicionar = false
      this.showUpload = false
      this.limpar()
    },

    async abrirModalGenerico (modelo) {
      if (modelo.acao === 'BAIXAR') {
        this.getDownload(modelo.item.documentoReurb)
      } else {
        this.showModalGenerico = true
        this.tipoAcao = modelo.acao
        this.modelo = { ...modelo.item }
      }
    },

    async excluirModelo () {
      this.excluirModeloDespacho({ id: this.modelo.id }).then(() => {
        this.closeModal()
        this.updateListagem()
      })
    },

    limpar () {
      this.updateListagem()
    },

    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    },
    uploadFile (file) {
      this.modelo.documentoReurb = {
        key: file.response,
        nome: file.name,
        tipo: {
          id: 193,
          codigo: 'DOCUMENTO_GABINETE'
        }
      }
      this.showUpload = false
    },
    async removeFile (documento) {
      this.confirmBox(this.$messages.DOCUMENTO_REMOVE_CONFIRM, this.$messages.TITULO_WARNING,
        () => {
          this.modelo.documentoReurb = null
          this.showUpload = true
        },
        () => { })
    },
    downloadDocumentoCadastro (documento) {
      this.getDownload(documento)
    }
  }
}
</script>

<style scoped lang="scss">
.card-container {
  margin: 20px;
  border-radius: 10px;
}

.container {
  padding: 20px;
}

.padding-titulo {
  padding-left: 10px;
}

.flex-buttons {
  display: flex;
  justify-content: space-between;
  padding: 0 15px;
}

@media (max-width: 780px) {
  .card-container {
    margin: 0;
  }

  .listagemModelo {
    margin: 15px 5px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/ModelosListagem.vue